import { Injectable } from '@angular/core';
import { StorageKeys } from '../helpers/enum';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  config:any;
  constructor() {}

  getProperty(key: string) {
    let val = window.localStorage.getItem(key);
    if (val !== null) {
      return JSON.parse(val);
    } else {
      return val;
    }
  }

  setProperty(key: string, value: any, parse = true) {
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  removeAllProperties() {
    window.localStorage.clear();
    return true;
  }

  removeProperty(key: string) {
    window.localStorage.removeItem(key);
    return true;
  }

  storageConfig() {
    this.config = {};
    if (this.getProperty(StorageKeys.config) != null) {
      this.config = Object.assign(this.config, this.getProperty(StorageKeys.config));
    }
    return this.config;
  }

  setConfig(config: any) {
    if (!this.config) {
      this.config = {};
    }
    this.config = Object.assign(this.config, config);
    this.setProperty(StorageKeys.config, this.config);
  }

}
